(function () {
  if (window.PurlifeCartDrawer) return;

  var drawer = document.querySelector('[data-purlife-cart-drawer]');
  if (!drawer) return;

  var panel = drawer.querySelector('.purlife-cart-drawer__panel');
  var itemsTarget = drawer.querySelector('[data-purlife-cart-items]');
  var subtotalTarget = drawer.querySelector('[data-purlife-cart-subtotal]');
  var relatedTarget = drawer.querySelector('[data-purlife-cart-related]');
  var eyebrowTarget = drawer.querySelector('[data-purlife-cart-eyebrow]');
  var relatedSource = document.querySelector('[data-purlife-cart-related-source]');
  var mobileMenu = document.querySelector('[data-purlife-mobile-menu]');
  var mobileMenuPanel = mobileMenu ? mobileMenu.querySelector('.purlife-mobile-menu__panel') : null;
  var favoritesDrawer = document.querySelector('[data-purlife-favorites-drawer]');
  var favoritesPanel = favoritesDrawer ? favoritesDrawer.querySelector('.purlife-favorites-drawer__panel') : null;
  var favoritesTarget = favoritesDrawer ? favoritesDrawer.querySelector('[data-purlife-favorites-items]') : null;
  var relatedProducts = [];
  var relatedVisibleCount = 4;

  try {
    relatedProducts = JSON.parse(relatedSource ? relatedSource.textContent : '[]') || [];
  } catch (error) {
    relatedProducts = [];
  }

  function money(cents) {
    var amount = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: window.Shopify && window.Shopify.currency && window.Shopify.currency.active ? window.Shopify.currency.active : 'USD'
      }).format(amount);
    } catch (error) {
      return '$' + amount.toFixed(2);
    }
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function cleanTitle(title) {
    return String(title || '').trim();
  }

  function truncateTitle(title) {
    var cleaned = cleanTitle(title);
    return cleaned.length > 100 ? cleaned.slice(0, 97).trim() + '...' : cleaned;
  }

  function findRelatedProductByVariant(variantId) {
    var target = String(variantId || '');
    if (!target) return null;
    for (var index = 0; index < relatedProducts.length; index += 1) {
      if (String(relatedProducts[index].variantId || '') === target) return relatedProducts[index];
    }
    return null;
  }

  function salePriceHtml(price, compare, save) {
    var hasSavings = Number(compare || 0) > Number(price || 0);
    return [
      '<div class="purlife-drawer-price">',
        hasSavings ? '<s>' + money(compare) + '</s>' : '',
        '<strong>' + money(price) + '</strong>',
        hasSavings ? '<em>Save ' + escapeHtml(save) + '%</em>' : '',
      '</div>'
    ].join('');
  }

  function updateCartCount(cart) {
    document.querySelectorAll('.purlife-sitebar__icons a[href*="/cart"] span').forEach(function (node) {
      node.textContent = cart.item_count || 0;
    });
    document.querySelectorAll('.purlife-quickbar [data-purlife-cart-trigger] em').forEach(function (node) {
      node.textContent = cart.item_count || 0;
    });
  }

  function getFavorites() {
    try {
      return JSON.parse(localStorage.getItem('purlifeFavorites') || '[]') || [];
    } catch (error) {
      return [];
    }
  }

  function setFavorites(favorites) {
    try {
      localStorage.setItem('purlifeFavorites', JSON.stringify(favorites));
    } catch (error) {}
  }

  function getFavoriteItems() {
    try {
      return JSON.parse(localStorage.getItem('purlifeFavoriteItems') || '{}') || {};
    } catch (error) {
      return {};
    }
  }

  function setFavoriteItems(items) {
    try {
      localStorage.setItem('purlifeFavoriteItems', JSON.stringify(items || {}));
    } catch (error) {}
  }

  function rememberFavorite(button) {
    if (!button || !button.dataset.productHandle) return;
    var items = getFavoriteItems();
    items[button.dataset.productHandle] = {
      handle: button.dataset.productHandle,
      title: button.dataset.productTitle || button.dataset.productHandle,
      url: button.dataset.productUrl || '/products/' + button.dataset.productHandle,
      image: button.dataset.productImage || '',
      price: button.dataset.productPrice || ''
    };
    setFavoriteItems(items);
  }

  function forgetFavorite(handle) {
    var items = getFavoriteItems();
    if (items[handle]) {
      delete items[handle];
      setFavoriteItems(items);
    }
  }

  function renderFavorites() {
    if (!favoritesTarget) return;
    var favorites = getFavorites();
    var items = getFavoriteItems();

    if (!favorites.length) {
      favoritesTarget.innerHTML = [
        '<div class="purlife-favorites-empty">',
          '<p>No saved products yet.</p>',
          '<a class="purlife-button" href="/collections/shop">Shop products</a>',
        '</div>'
      ].join('');
      return;
    }

    favoritesTarget.innerHTML = favorites.map(function (handle) {
      var item = items[handle] || {
        handle: handle,
        title: handle.replace(/-/g, ' '),
        url: '/products/' + handle,
        image: '',
        price: ''
      };
      var favoriteTitle = truncateTitle(item.title);
      var image = item.image ? '<a class="purlife-favorite-item__media" href="' + escapeHtml(item.url) + '"><img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(favoriteTitle) + '" loading="lazy"></a>' : '<a class="purlife-favorite-item__media" href="' + escapeHtml(item.url) + '"></a>';
      return [
        '<article class="purlife-favorite-item">',
          image,
          '<div class="purlife-favorite-item__content">',
            '<a href="' + escapeHtml(item.url) + '">' + escapeHtml(favoriteTitle) + '</a>',
            item.price ? '<span>' + escapeHtml(item.price) + '</span>' : '',
          '</div>',
          '<button class="purlife-favorite-item__remove" type="button" aria-label="Remove ' + escapeHtml(favoriteTitle) + ' from favorites" data-purlife-favorite-remove="' + escapeHtml(handle) + '">',
            '<i class="fa fa-times" aria-hidden="true"></i>',
          '</button>',
        '</article>'
      ].join('');
    }).join('');
  }

  function updateFavoritesUI() {
    var favorites = getFavorites();
    document.querySelectorAll('[data-purlife-favorite]').forEach(function (button) {
      var handle = button.dataset.productHandle;
      var active = favorites.indexOf(handle) !== -1;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      button.setAttribute('aria-label', (active ? 'Remove ' : 'Save ') + (button.dataset.productTitle || 'product') + (active ? ' from favorites' : ''));
      var icon = button.querySelector('i');
      if (icon) {
        if (button.classList.contains('purlife-card__favorite')) {
          icon.classList.toggle('fa-heart', active);
          icon.classList.toggle('fa-heart-o', !active);
          icon.classList.remove('fa-times');
        } else {
          icon.classList.toggle('fa-times', active);
          icon.classList.toggle('fa-heart-o', !active);
          icon.classList.remove('fa-heart');
        }
      }
      var label = button.querySelector('span');
      if (label && button.classList.contains('purlife-save-link')) {
        label.textContent = active ? 'Remove from favorites' : 'Save for later';
      }
    });
    document.querySelectorAll('[data-purlife-favorite-count]').forEach(function (node) {
      node.textContent = favorites.length;
      node.hidden = favorites.length === 0;
    });
    renderFavorites();
  }

  function requestJSON(url, options) {
    options = options || {};
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open(options.method || 'GET', url, true);
      xhr.setRequestHeader('Accept', 'application/json');
      if (options.contentType) xhr.setRequestHeader('Content-Type', options.contentType);
      xhr.onreadystatechange = function () {
        if (xhr.readyState !== 4) return;
        var payload = {};
        try {
          payload = xhr.responseText ? JSON.parse(xhr.responseText) : {};
        } catch (error) {
          payload = {};
        }
        if (xhr.status >= 200 && xhr.status < 300) {
          resolve(payload);
        } else {
          reject(payload);
        }
      };
      xhr.onerror = function () {
        reject(new Error('Cart request failed'));
      };
      xhr.send(options.body || null);
    });
  }

  function renderItems(cart) {
    if (!itemsTarget) return;

    if (!cart.items || !cart.items.length) {
      itemsTarget.innerHTML = '<div class="purlife-cart-drawer__empty">Your cart is empty.</div>';
      return;
    }

    itemsTarget.innerHTML = cart.items.map(function (item) {
      var title = truncateTitle(item.product_title || item.title);
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<p>' + escapeHtml(item.variant_title) + '</p>' : '';
      var image = item.image ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(title) + '" loading="lazy">' : '';
      var saleProduct = findRelatedProductByVariant(item.variant_id);
      var unitPrice = saleProduct ? saleProduct.price : item.final_price;
      var linePrice = Number(unitPrice || 0) * Number(item.quantity || 1);
      var lineCompare = saleProduct && Number(saleProduct.compare || 0) > Number(saleProduct.price || 0) ? Number(saleProduct.compare || 0) * Number(item.quantity || 1) : null;
      var savePercent = saleProduct && saleProduct.save ? saleProduct.save : null;
      var priceHtml = salePriceHtml(linePrice || item.final_line_price, lineCompare, savePercent);
      return [
        '<article class="purlife-drawer-item" data-purlife-drawer-item>',
          '<a class="purlife-drawer-item__media" href="' + escapeHtml(item.url) + '">' + image + '</a>',
          '<div class="purlife-drawer-item__content">',
            '<a href="' + escapeHtml(item.url) + '">' + escapeHtml(title) + '</a>',
            variant,
            '<span>Qty ' + escapeHtml(item.quantity) + '</span>',
          '</div>',
          priceHtml,
          '<button class="purlife-drawer-item__remove" type="button" aria-label="Remove ' + escapeHtml(title) + ' from cart" data-purlife-cart-remove="' + escapeHtml(item.key) + '">',
            '<i class="fa fa-times" aria-hidden="true"></i>',
          '</button>',
        '</article>'
      ].join('');
    }).join('');
  }

  function renderRelated(cart) {
    if (!relatedTarget) return;

    var cartVariantIds = (cart.items || []).map(function (item) {
      return String(item.variant_id);
    });
    var allPicks = relatedProducts.filter(function (product) {
      return product.variantId && cartVariantIds.indexOf(String(product.variantId)) === -1;
    });
    var picks = allPicks.slice(0, relatedVisibleCount);

    if (!picks.length) {
      relatedTarget.innerHTML = '';
      return;
    }

    var cards = picks.map(function (product) {
      var image = product.image ? '<img src="' + escapeHtml(product.image) + '" alt="' + escapeHtml(product.title) + '" loading="lazy">' : '';
      var title = truncateTitle(product.title);
      var priceHtml = salePriceHtml(product.price, product.compare, product.save);
      return [
        '<article class="purlife-drawer-related-card">',
          '<a class="purlife-drawer-related__media" href="' + escapeHtml(product.url) + '">' + image + '</a>',
          '<div>',
            '<a href="' + escapeHtml(product.url) + '">' + escapeHtml(title) + '</a>',
            priceHtml,
            '<button type="button" data-purlife-drawer-add="' + escapeHtml(product.variantId) + '">Add</button>',
          '</div>',
        '</article>'
      ].join('');
    }).join('');

    var loadMore = allPicks.length > relatedVisibleCount
      ? '<button class="purlife-drawer-load-more" type="button" data-purlife-related-more>Load more</button>'
      : '';

    relatedTarget.innerHTML = cards + loadMore;
  }

  function render(cart) {
    renderItems(cart);
    renderRelated(cart);
    if (subtotalTarget) subtotalTarget.textContent = money(cart.total_price);
    updateCartCount(cart);
  }

  function resetRelatedLimit() {
    relatedVisibleCount = 4;
  }

  function setDrawerMode(mode) {
    if (!eyebrowTarget) return;
    eyebrowTarget.textContent = mode === 'added' ? 'Added to cart' : 'Shopping bag';
  }

  function openDrawer() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('purlife-cart-drawer-lock');
    if (panel) panel.focus();
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('purlife-cart-drawer-lock');
  }

  function openMobileMenu(trigger) {
    if (!mobileMenu) return;
    mobileMenu.classList.add('is-open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    document.body.classList.add('purlife-menu-lock');
    document.querySelectorAll('[data-purlife-menu-trigger]').forEach(function (button) {
      button.setAttribute('aria-expanded', 'true');
    });
    if (mobileMenuPanel) mobileMenuPanel.focus();
  }

  function closeMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('is-open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('purlife-menu-lock');
    document.querySelectorAll('[data-purlife-menu-trigger]').forEach(function (button) {
      button.setAttribute('aria-expanded', 'false');
    });
  }

  function openFavoritesDrawer() {
    if (!favoritesDrawer) return;
    renderFavorites();
    closeMobileMenu();
    closeDrawer();
    favoritesDrawer.classList.add('is-open');
    favoritesDrawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('purlife-favorites-drawer-lock');
    if (favoritesPanel) favoritesPanel.focus();
  }

  function closeFavoritesDrawer() {
    if (!favoritesDrawer) return;
    favoritesDrawer.classList.remove('is-open');
    favoritesDrawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('purlife-favorites-drawer-lock');
  }

  async function refreshCart() {
    return requestJSON('/cart.js');
  }

  async function addForm(form, submitter) {
    if (submitter) {
      submitter.disabled = true;
      submitter.dataset.purlifeOriginalText = submitter.textContent;
      submitter.textContent = 'Adding';
    }

    try {
      await requestJSON('/cart/add.js', {
        method: 'POST',
        body: new FormData(form)
      });
      var cart = await refreshCart();
      resetRelatedLimit();
      render(cart);
      setDrawerMode('added');
      openDrawer();
    } catch (error) {
      form.submit();
    } finally {
      if (submitter) {
        submitter.disabled = false;
        submitter.textContent = submitter.dataset.purlifeOriginalText || 'Add to cart';
      }
    }
  }

  async function openCurrentCart(trigger) {
    if (trigger) trigger.classList.add('is-loading');
    try {
      var cart = await refreshCart();
      resetRelatedLimit();
      render(cart);
      setDrawerMode('current');
      openDrawer();
    } catch (error) {
      if (trigger && trigger.getAttribute('href')) {
        window.location.href = trigger.getAttribute('href');
      }
    } finally {
      if (trigger) trigger.classList.remove('is-loading');
    }
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;

    var submitter = event.submitter;
    var submitterAction = submitter ? submitter.getAttribute('formaction') || '' : '';
    var submitterText = submitter ? submitter.textContent || '' : '';
    if (submitterAction.indexOf('/checkout') !== -1 || /buy now/i.test(submitterText)) return;

    event.preventDefault();
    addForm(form, submitter);
  });

  document.addEventListener('click', function (event) {
    var menuTrigger = event.target.closest('[data-purlife-menu-trigger]');
    if (menuTrigger) {
      event.preventDefault();
      openMobileMenu(menuTrigger);
      return;
    }

    var menuClose = event.target.closest('[data-purlife-menu-close]');
    if (menuClose) {
      event.preventDefault();
      closeMobileMenu();
      return;
    }

    var cartTrigger = event.target.closest('[data-purlife-cart-trigger]');
    if (cartTrigger) {
      event.preventDefault();
      closeMobileMenu();
      closeFavoritesDrawer();
      openCurrentCart(cartTrigger);
      return;
    }

    var favoritesTrigger = event.target.closest('[data-purlife-favorites-trigger]');
    if (favoritesTrigger) {
      event.preventDefault();
      openFavoritesDrawer();
      return;
    }

    var favoritesClose = event.target.closest('[data-purlife-favorites-close]');
    if (favoritesClose) {
      event.preventDefault();
      closeFavoritesDrawer();
      return;
    }

    var favoriteRemove = event.target.closest('[data-purlife-favorite-remove]');
    if (favoriteRemove) {
      event.preventDefault();
      var removeHandle = favoriteRemove.dataset.purlifeFavoriteRemove;
      setFavorites(getFavorites().filter(function (handle) {
        return handle !== removeHandle;
      }));
      forgetFavorite(removeHandle);
      updateFavoritesUI();
      return;
    }

    var favoriteButton = event.target.closest('[data-purlife-favorite]');
    if (!favoriteButton) return;
    event.preventDefault();

    var handle = favoriteButton.dataset.productHandle;
    if (!handle) return;

    var favorites = getFavorites();
    var index = favorites.indexOf(handle);
    if (index === -1) {
      favorites.push(handle);
      rememberFavorite(favoriteButton);
    } else {
      favorites.splice(index, 1);
      forgetFavorite(handle);
    }
    setFavorites(favorites);
    updateFavoritesUI();
  });

  drawer.addEventListener('click', async function (event) {
    var closeButton = event.target.closest('[data-purlife-cart-close]');
    if (closeButton) {
      closeDrawer();
      return;
    }

    var addButton = event.target.closest('[data-purlife-drawer-add]');
    var moreButton = event.target.closest('[data-purlife-related-more]');
    var removeButton = event.target.closest('[data-purlife-cart-remove]');
    if (removeButton) {
      removeButton.disabled = true;
      try {
        var updatedCart = await requestJSON('/cart/change.js', {
          method: 'POST',
          contentType: 'application/json',
          body: JSON.stringify({ id: removeButton.dataset.purlifeCartRemove, quantity: 0 })
        });
        render(updatedCart);
        setDrawerMode('current');
      } catch (error) {
        removeButton.disabled = false;
      }
      return;
    }

    if (moreButton) {
      relatedVisibleCount += 4;
      try {
        var currentCart = await refreshCart();
        renderRelated(currentCart);
      } catch (error) {}
      return;
    }

    if (!addButton) return;

    addButton.disabled = true;
    addButton.textContent = 'Adding';
    try {
      await requestJSON('/cart/add.js', {
        method: 'POST',
        contentType: 'application/json',
        body: JSON.stringify({ id: Number(addButton.dataset.purlifeDrawerAdd), quantity: 1 }),
      });
      var cart = await refreshCart();
      render(cart);
      setDrawerMode('added');
    } catch (error) {
      addButton.textContent = 'Add';
    } finally {
      addButton.disabled = false;
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    if (event.key === 'Escape' && mobileMenu && mobileMenu.classList.contains('is-open')) closeMobileMenu();
    if (event.key === 'Escape' && favoritesDrawer && favoritesDrawer.classList.contains('is-open')) closeFavoritesDrawer();
  });

  window.PurlifeCartDrawer = {
    open: openDrawer,
    close: closeDrawer,
    openCurrentCart: openCurrentCart,
    openFavorites: openFavoritesDrawer,
    closeFavorites: closeFavoritesDrawer,
    openMobileMenu: openMobileMenu,
    closeMobileMenu: closeMobileMenu,
    render: render,
    updateFavoritesUI: updateFavoritesUI
  };

  updateFavoritesUI();
})();

/*
 * Shopify's root HTML cache can occasionally retain an obsolete PageFly home
 * response for WebKit clients. The section API is rendered from the active
 * theme, so use it for the branded Home controls while preserving the normal
 * root link as the no-JavaScript fallback.
 */
(function () {
  if (window.PurlifeHomeNavigation) return;
  window.PurlifeHomeNavigation = true;

  var sectionId = 'purlife-modern-homepage-edge';
  var isLoading = false;
  var renderedFromSection = false;

  function isRootLink(link) {
    if (!link || !link.getAttribute) return false;
    var href = link.getAttribute('href') || '';
    return href === '/' || href === window.location.origin + '/';
  }

  function isHomeControl(link) {
    if (!isRootLink(link)) return false;
    if (link.classList.contains('purlife-sitebar__brand')) return true;
    if (link.closest('.purlife-quickbar') && link.querySelector('.fa-home')) return true;
    return Boolean(link.closest('.purlife-mobile-menu__actions') && link.textContent.trim() === 'Home');
  }

  function findHomeControl(target) {
    var node = target;
    while (node && node !== document) {
      if (node.nodeType === 1 && node.tagName === 'A' && isHomeControl(node)) return node;
      node = node.parentNode;
    }
    return null;
  }

  function copySectionStyles(source) {
    document.querySelectorAll('[data-purlife-home-section-style]').forEach(function (style) {
      style.remove();
    });

    source.querySelectorAll('style').forEach(function (style) {
      var copy = document.createElement('style');
      copy.setAttribute('data-purlife-home-section-style', '');
      copy.textContent = style.textContent;
      document.head.appendChild(copy);
    });
  }

  function runScripts(scripts) {
    scripts.forEach(function (script) {
      var type = script.getAttribute('type');
      if (type && type !== 'text/javascript' && type !== 'application/javascript') return;

      var replacement = document.createElement('script');
      if (script.src) {
        replacement.src = script.src;
      } else {
        replacement.textContent = script.textContent;
      }
      script.parentNode.replaceChild(replacement, script);
    });
  }

  function renderHomepage(markup, historyMode) {
    var source = document.createElement('div');
    source.innerHTML = markup;

    var sourceRoot = source.querySelector('[data-purlife-home]');
    var currentRoot = document.querySelector('.purlife-modern');
    var sourceData = sourceRoot && sourceRoot.querySelector('[data-purlife-cart-related-source]');
    var currentData = currentRoot && currentRoot.querySelector('[data-purlife-cart-related-source]');
    if (!sourceRoot || !currentRoot || !sourceData || !currentData) return false;

    copySectionStyles(source);
    currentRoot.className = sourceRoot.className;
    currentRoot.removeAttribute('data-purlife-product');
    currentRoot.removeAttribute('data-purlife-collection');
    currentRoot.removeAttribute('data-purlife-page');
    currentRoot.setAttribute('data-purlife-home', '');
    currentRoot.setAttribute('data-cache-refresh', sourceRoot.getAttribute('data-cache-refresh') || '');
    currentData.textContent = sourceData.textContent;

    while (currentData.nextSibling) {
      currentRoot.removeChild(currentData.nextSibling);
    }

    var sourceNodes = Array.prototype.slice.call(sourceRoot.childNodes);
    var sourceDataIndex = sourceNodes.indexOf(sourceData);
    var scripts = [];
    sourceNodes.slice(sourceDataIndex + 1).forEach(function (node) {
      var copy = node.cloneNode(true);
      currentRoot.appendChild(copy);
      if (copy.nodeType === 1 && copy.tagName === 'SCRIPT') scripts.push(copy);
    });

    runScripts(scripts);
    renderedFromSection = true;
    var state = { purlifeHomeSection: true };
    if (historyMode === 'replace') {
      window.history.replaceState(state, '', '/');
    } else {
      window.history.pushState(state, '', '/');
    }
    window.scrollTo(0, 0);
    return true;
  }

  function requestHomepage(historyMode, fallbackHref) {
    if (isLoading) return;
    isLoading = true;

    var request = new XMLHttpRequest();
    request.open('GET', '/?sections=' + encodeURIComponent(sectionId), true);
    request.setRequestHeader('Accept', 'application/json');
    request.timeout = 12000;
    request.onreadystatechange = function () {
      if (request.readyState !== 4) return;
      isLoading = false;

      var response = null;
      try {
        response = JSON.parse(request.responseText || '{}');
      } catch (error) {}

      if (request.status >= 200 && request.status < 300 && response && response[sectionId] && renderHomepage(response[sectionId], historyMode)) {
        return;
      }
      window.location.assign(fallbackHref || '/');
    };
    request.onerror = function () {
      if (request.readyState === 4) return;
      isLoading = false;
      window.location.assign(fallbackHref || '/');
    };
    request.ontimeout = function () {
      isLoading = false;
      window.location.assign(fallbackHref || '/');
    };
    request.send();
  }

  window.addEventListener('popstate', function (event) {
    if (!renderedFromSection) return;
    if (event.state && event.state.purlifeHomeSection) {
      requestHomepage('replace', '/');
      return;
    }
    window.location.reload();
  });
})();
